import { NgxSpinnerModule, NgxSpinnerService } from 'ngx-spinner';
import { Component, OnInit } from '@angular/core';
import * as $ from 'jquery';
@Component({
  selector: 'loading-first',
  templateUrl: './loading-first.component.html',
  styleUrls: ['./loading-first.component.css']
})
export class LoadingFirstComponent implements OnInit {

  constructor(
    public spinner: NgxSpinnerService
  ) { }

  ngOnInit(): void {
    this.spinner.show();


    setTimeout(() => {
      this.spinner.hide();
    }, 2500);
    $(function () {
      // setTimeout(() => {
      //   $('.floating_wrap').and({ display: 'none' })
      // }, 1000);

      // $('.floating_wrap').animate({ opacity: 0 }, 3000)

    });
  }

}
